var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snackbar-wrapper ml-0 mr-0 pl-0 pr-0"})}
var staticRenderFns = []

export { render, staticRenderFns }